(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_flexi-layout-columns"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  function shouldUseSlider() {
    return window.innerWidth <= 900;
  }

  function initBlazeSliders(target = document) {
    target.querySelectorAll('.flexi-columns-slider').forEach((el) => {
      if (!shouldUseSlider() || el.classList.contains('blaze-initialized')) return;

      const mobileSlides = parseFloat(el.dataset.blazeMobile) || 1.2;
      const tabletSlides = parseFloat(el.dataset.blazeTablet) || 2.2;
      const loop = el.dataset.blazeLoop === 'true';
      const draggable = el.dataset.blazeDraggable === 'true';

      new BlazeSlider(el, {
        '(max-width: 900px)': {
          slidesToShow: tabletSlides,
          slidesToScroll: 1,
          transitionDuration: 200,
          loop: loop,
          draggable: draggable,
        },
        '(max-width: 500px)': {
          slidesToShow: mobileSlides,
          slidesToScroll: 1,
          transitionDuration: 200,
          loop: loop,
          draggable: draggable,
        },
      });

      el.classList.add('blaze-initialized');
    });
  }

  function destroyBlazeSliders(target = document) {
    target.querySelectorAll('.blaze-initialized').forEach((el) => {
      const track = el.querySelector('.blaze-track');
      if (!track) return;

      const restoredGrid = track.cloneNode(true);
      restoredGrid.className = 'flexi-columns-grid';
      el.parentNode.replaceChild(restoredGrid, el);
    });
  }

  function handleResize() {
    if (shouldUseSlider()) {
      initBlazeSliders();
    } else {
      destroyBlazeSliders();
    }
  }

  // Initial run
  handleResize();

  // On section load (e.g., theme editor)
  document.addEventListener('shopify:section:load', function (event) {
    handleResize(event.target);
  });

  // Debounced resize handler
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 300);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-featured-images"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
        let images = document.querySelectorAll('.flexi-featured-img, .flexi-featured-placeholder-img');
        let currentIndex = 0;
    
        images[0].style.display = 'block';
    
        function showNextImage() {
        images[currentIndex].style.display = 'none'; 
        images[currentIndex].classList.remove('flexi-featured-image-fade');
    
        currentIndex = (currentIndex + 1) % images.length;
        images[currentIndex].style.display = 'block';
        images[currentIndex].classList.add('flexi-featured-image-fade'); 
    
        let loadingBar = document.querySelector('.flexi-loading-bar');
        loadingBar.style.animation = 'none';
        loadingBar.offsetHeight;
        loadingBar.style.animation = '';
        }
    
        setInterval(showNextImage, 3000);
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-rotating-images"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  function initBlazeSliders(target = document) {
    target.querySelectorAll('.flexi-blaze-rotating-images').forEach((el) => {
      const parent = el.parentNode;
      const clone = el.cloneNode(true);
      parent.replaceChild(clone, el);

      const loop = clone.dataset.blazeLoop === 'true';
      const draggable = clone.dataset.blazeDraggable === 'true';
      const autoplay = clone.dataset.blazeAutoplay === 'true';
      const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
      const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

      new BlazeSlider(clone, {
        all: {
          slidesToShow: 1,
          slidesToScroll: 1,
          transitionDuration: 200,
          slideGap: '0px',
          loop: loop,
          draggable: draggable,
          autoplayInterval: autoplayDuration,
          enableAutoplay: autoplay,
          stopAutoplayOnInteraction: autoplayPause,
          prevArrow: el.querySelector('.blaze-prev'), 
          nextArrow: el.querySelector('.blaze-next'), 
        },
      });
    });
  }

  initBlazeSliders();

  document.addEventListener('shopify:section:load', function (event) {
    initBlazeSliders(event.target);
  });

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initBlazeSliders();
    }, 300);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  function initBlazeSliders(target = document) {
    target.querySelectorAll('.flexi-blaze-slider').forEach((el) => {
      const parent = el.parentNode;
      const clone = el.cloneNode(true);
      parent.replaceChild(clone, el);

      const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
      const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
      const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
      const loop = clone.dataset.blazeLoop === 'true';
      const draggable = clone.dataset.blazeDraggable === 'true';
      const autoplay = clone.dataset.blazeAutoplay === 'true';
      const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
      const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

      new BlazeSlider(clone, {
        all: {
          slidesToShow: desktopSlides,
          slidesToScroll: 1,
          transitionDuration: 200,
          loop: loop,
          draggable: draggable,
          autoplayInterval: autoplayDuration,
          enableAutoplay: autoplay,
          stopAutoplayOnInteraction: autoplayPause,
          prevArrow: el.querySelector('.blaze-prev'), 
          nextArrow: el.querySelector('.blaze-next'), 
        },
        '(max-width: 900px)': {
          slidesToShow: tabletSlides,
        },
        '(max-width: 500px)': {
          slidesToShow: mobileSlides,
        },
      });
    });
  }

  initBlazeSliders();

  document.addEventListener('shopify:section:load', function (event) {
    initBlazeSliders(event.target);
  });

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initBlazeSliders();
    }, 300);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-slideshow"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  function initBlazeSliders(target = document) {
    target.querySelectorAll('.flexi-blaze-slideshow').forEach((el) => {
      const parent = el.parentNode;
      const clone = el.cloneNode(true);
      parent.replaceChild(clone, el);

      const loop = clone.dataset.blazeLoop === 'true';
      const draggable = clone.dataset.blazeDraggable === 'true';
      const autoplay = clone.dataset.blazeAutoplay === 'true';
      const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
      const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

      new BlazeSlider(clone, {
        all: {
          slidesToShow: 1,
          slidesToScroll: 1,
          transitionDuration: 200,
          loop: loop,
          draggable: draggable,
          autoplayInterval: autoplayDuration,
          enableAutoplay: autoplay,
          stopAutoplayOnInteraction: autoplayPause,
          prevArrow: el.querySelector('.blaze-prev'), 
          nextArrow: el.querySelector('.blaze-next'), 
        },
      });
    });
  }

  initBlazeSliders();

  document.addEventListener('shopify:section:load', function (event) {
    initBlazeSliders(event.target);
  });

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initBlazeSliders();
    }, 300);
  });
});
  } catch(e) { console.error(e); }
})();

})();
